import { render, staticRenderFns } from "./qianshou.vue?vue&type=template&id=0b44fa55&scoped=true&"
import script from "./qianshou.vue?vue&type=script&lang=js&"
export * from "./qianshou.vue?vue&type=script&lang=js&"
import style0 from "./qianshou.vue?vue&type=style&index=0&id=0b44fa55&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b44fa55",
  null
  
)

export default component.exports